import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./modules/inicio/context/AuthContext";
import ErrorBoundary from "./modules/inicio/components/ErrorBoundary";
import MainLayout from "./modules/inicio/components/MainLayout";
import RutaPrivada from "./modules/inicio/components/RutaPrivada";
import RutaPublica from "./modules/inicio/components/RutaPublica";
import Home from "./modules/inicio/pages/Home";
import Login from "./modules/inicio/pages/Login";
import Registro from "./modules/inicio/pages/Registro";
import RestablecerPassword from "./modules/inicio/pages/RestablecerPassword";
import AdminUsuarios from "./modules/inicio/pages/AdminUsuarios";
import TablaDiscapacidad from "./modules/estrategias/rbc/pages/TablaDiscapacidad";
import TablaVejez from "./modules/estrategias/vejez/pages/TablaVejez";
import TablaMigrante from "./modules/estrategias/migrante/pages/TablaMigrante";
import TablaHabitanteCalle from "./modules/estrategias/habitante_calle/pages/TablaHabitanteCalle";
import DashboardGeneral from "./modules/dashboard/pages/DashboardGeneral";

// Se importa solo por su efecto secundario: registra cada estrategia con
// soporte offline en el motor central de sincronización, antes de que se
// monte el OfflineBanner (que vive dentro de MainLayout).
import "./modules/inicio/offline/registrarProveedoresSync";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <MainLayout>
          <Routes>
            <Route path="/login" element={<RutaPublica><Login /></RutaPublica>} />
            <Route path="/registro" element={<RutaPublica><Registro /></RutaPublica>} />
            <Route path="/restablecer-password" element={<RutaPublica><RestablecerPassword /></RutaPublica>} />

            <Route path="/" element={<RutaPrivada><Home /></RutaPrivada>} />
            <Route
              path="/admin"
              element={
                <RutaPrivada rolesPermitidos={["admin"]}>
                  <AdminUsuarios />
                </RutaPrivada>
              }
            />
            <Route path="/rbc" element={<RutaPrivada programaRequerido="rbc"><TablaDiscapacidad /></RutaPrivada>} />
            <Route path="/vejez" element={<RutaPrivada programaRequerido="vejez"><TablaVejez /></RutaPrivada>} />
            <Route path="/migrante" element={<RutaPrivada programaRequerido="migrante"><TablaMigrante /></RutaPrivada>} />
            <Route path="/habitante-calle" element={<RutaPrivada programaRequerido="habitante_calle"><TablaHabitanteCalle /></RutaPrivada>} />
            <Route
              path="/dashboard"
              element={
                <RutaPrivada rolesPermitidos={["admin"]}>
                  <DashboardGeneral />
                </RutaPrivada>
              }
            />
          </Routes>
        </MainLayout>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
